import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as TipoParticipantes from "../../constantes/TipoParticipantesTorneo.js";
import useGetListaURL from "../../../hooks/useGetListaURL.js";

const ListaTiposTorneoOrganizador = (props) => {
  const organizador = props.organizador;
  const styles = props.styles;
  const [listaTiposTorneo, setListaTiposTorneo] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (organizador) {
      fetchData(
        "tipos_torneo?oficialidad=" +
          organizador.oficialidad +
          "&tipoParticipacion=" +
          TipoParticipantes.SELECCIONES,
        setListaTiposTorneo
      );
    } else {
      setListaTiposTorneo([]);
    }
  }, [organizador, fetchData]);

  return (
    <React.Fragment>
      {listaTiposTorneo && listaTiposTorneo.length > 0 && (
        <React.Fragment>
          {listaTiposTorneo.map((tipoTorneo, index) => (
            <tr key={index} className={`${styles.fila}`}>
              <td className={`${styles.tipoTorneo}`}>
                <Link to={"/torneosInt/" + tipoTorneo.codigo}>{tipoTorneo.nombre}</Link>
              </td>
            </tr>
          ))}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default ListaTiposTorneoOrganizador;
